<ng-container *transloco="let convert;">
  <div id="question-drawer" class="question-drawer" >
    <header class="questionHeader">
      <div class="question-drawer__header" role="alert">
        <h2 class="text-brand fw-normal" tabindex="-1">
          @if (status === 'unanswered' && auctionItemStatus !== 'SOLD') {
            <span>{{convert('sellModule.question.questionDrawer.textReply')}}</span>
          }
          @if (status === 'answered') {
            <span>{{convert('sellModule.question.questionDrawer.textHistory')}}</span>
          }
        </h2>
        <div class="disclosures">
          <p><span class="disclosures__label">{{convert('sellModule.question.questionDrawer.textDisclaimer')}}</span> {{convert('sellModule.question.questionDrawer.textDeleteAnswer')}}</p>
        </div>
      </div>
    </header>

    <div class="question-drawer__inner collapse-body">
      <trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
        @if (open) {
          <lib-view-history
            [dealerUuid]="dealer.dealerUuid"
          [userUuid]="userUuid" [index]="questionIndex"></lib-view-history>
        }
        @if (status === 'unanswered' && !question.questions[0].readOnly) {
          <lib-reply
            [question]="question"
            (toggle)="toggle()"
            (answer)="handleAnswer($event)"
            [questionError]= "questionError"
          ></lib-reply>
        }
        <button
          (click)="toggle()"
          class="question-drawer__close"
          [attr.aria-label]="convert('sellModule.question.questionDrawer.ariaLabelCloseDrawer')"
          data-track-elem="icon"
          data-track-name="Close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </trap-focus>
    </div>
  </div>
</ng-container>
